import { z } from 'zod';
import { educationSchema } from '../education/index.js';
export const userEducationSchema = educationSchema.extend({
    date: z.iso.datetime(),
});
